
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"26","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"3","cy":"3","r":"3"}}),_c('circle',{attrs:{"cx":"13","cy":"3","r":"3"}}),_c('circle',{attrs:{"cx":"13","cy":"13","r":"3"}}),_c('circle',{attrs:{"cx":"3","cy":"13","r":"3"}}),_c('circle',{attrs:{"cx":"3","cy":"23","r":"3"}}),_c('circle',{attrs:{"cx":"13","cy":"23","r":"3"}})])
          )
        }
      }
    